import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getCompanydata } from "../store/adminSlice";
import URL from "../functions/URLString";

function Logo() {
  const dispatch = useDispatch();
  const [companyLogo, setCompanyLogo] = useState("");
  const _id = useSelector((state) => state.admin._id);
  const stateCompanyLogo = useSelector((state) => state.admin.companyLogo);
  useEffect(() => {
    setCompanyLogo(stateCompanyLogo);
  }, [stateCompanyLogo]);
  useEffect(() => {
    dispatch(getCompanydata(_id));
    setCompanyLogo(stateCompanyLogo);
  }, []);
  return (
    <>
      <img
        className="w-38 h-14 md:w-auto md:h-[100px] xxl:w-auto xxl:h-[100px] mb-2 object-contain"
        src={
          companyLogo !== ""
            ? `${URL}/uploads/` + stateCompanyLogo
            : process.env.PUBLIC_URL + "/logo-sdl.png"
        }
        alt="logo"
      />
    </>
  );
}

export default Logo;
